import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/navbar-icons/search.svg'
import _imports_1 from '../../assets/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-72d4f336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center w-full focus:bg-white" }
const _hoisted_2 = {
  class: "flex flex-row bg-background rounded-2xl py-4 w-full",
  style: {"background-color":"#f7f7fc"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mx-4"
}, null, -1))
const _hoisted_4 = ["name", "value", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        type: "text",
        name: _ctx.name,
        value: _ctx.modelValue,
        onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
        onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkValue && _ctx.checkValue(...args))),
        placeholder: _ctx.placeholder,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        style: {"background-color":"#f7f7fc"},
        class: "apperance-none border-0 rounded-2xl w-full bg-background px-4 focus:outline-none focus:ring-0 focus:ring-black focus:bg-white"
      }, null, 40, _hoisted_4),
      (_ctx.clearButton && _ctx.clear)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
            src: _imports_1,
            class: "cursor-pointer"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}